import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Header from "./components/Header";
import { HelmetProvider } from "react-helmet-async";
import Hero from "./components/Hero";
import "bootstrap-icons/font/bootstrap-icons.css";
import Services from "./pages/Services";
import About from "./pages/Aboutsection";
import Cta from "./pages/Cta";
import Footer from "./components/Footer";
import Floatingbuttons from "./components/Floatingbuttons";
import { useRef } from "react";
import ContactUs from "./components/Contactus";
import AdobePdfBlog from "./pages/Adobepdfblog";
import NotepadPlugins from "./pages/Notepadplugins";
import Http502 from "./pages/Http502";
import Cxx from "./pages/Cxx";
import Winscp from "./pages/Winscp";
import CPanelPassword from "./pages/Cpanelpassword";
import ClearingCache from "./pages/Clearingcache";
import Filezilla from "./pages/Filezilla";
import Ftp from "./pages/Ftp";
import Turbopayz from "./pages/Turbopayz";
import ColorPickerTool from "./pages/Colorcodegenrator";
import JpegToPdfConverter from "./pages/Jpegtopdfconverter";
import PngToPdfConverter from "./pages/Pngtopdfconverter";
import JsonViewerTool from "./pages/Jsonviewertool";
import QrCodeGenrator from "./pages/Qrcodegenrator";
import BarCodeGenrator from "./pages/Barcodegenrator";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Disclaimer from "./pages/Disclaimer";
import Termsncondition from "./pages/Termsncondition";
import Error500 from "./pages/InternalError";
import Error400 from "./pages/BadRequest";
import Error503 from "./pages/ServiceUnavailable";
import Sitemap from "./pages/Sitemap";
import PageTracking from "./utils/PageTracking";
import ScrollToTop from "./pages/ScrollToTop";
import Portfolio from "./pages/Portfolio";
import Shreegeneralstore from "./pages/Shreegeneralstore";
import Ourportfolio from "./pages/Ourportfolio";

function MainApp() {

  const aboutRef = useRef(null);
  const location = useLocation();

  const hideLayout = location.pathname === "/shreegeneralstore";

  return (
    <>

      {!hideLayout && <Header aboutRef={aboutRef} />}

      <Routes>

        <Route
          path="/"
          element={
            <>
              <Hero />
              <Services />
              <About aboutRef={aboutRef} />
              <Cta />
            </>
          }
        />

        <Route path="/contact" element={<ContactUs />} />

        <Route path="/shreegeneralstore" element={<Shreegeneralstore />} />

        <Route path="/adobe_pdf" element={<AdobePdfBlog />} />
        <Route path="/notepad_plugins" element={<NotepadPlugins />}/>
        <Route path="/http_502" element={<Http502 />}/>
        <Route path="/cxx" element={<Cxx />}/>
        <Route path="/winscp" element={<Winscp />}/>
        <Route path="/cpanelpassword" element={<CPanelPassword />}/>
        <Route path="/clearingcache" element={<ClearingCache />}/>
        <Route path="/filezilla" element={<Filezilla />}/>
        <Route path="/ftp" element={<Ftp/>}/>
        <Route path="/Turbopayz" element={<Turbopayz />}/>
        <Route path="/colorpickertool" element={<ColorPickerTool/>}/>
        <Route path="/jpegtopdfconverter" element={<JpegToPdfConverter/>}/>
        <Route path="/pngtopdfconverter" element={<PngToPdfConverter/>}/>
        <Route path="/jsonviewertool" element={<JsonViewerTool/>}/>
        <Route path="/qrcodegenrator" element={<QrCodeGenrator/>}/>
        <Route path="/barcodegenrator" element={<BarCodeGenrator/>}/>
        <Route path="/portfolio" element={<Portfolio/>}/>
        <Route path="/ourportfolio" element={<Ourportfolio/>}/>
        <Route path="*" element={<NotFound/>}/>
        <Route path="/privacypolicy" element={<PrivacyPolicy/>}/>
        <Route path="/disclaimer" element={<Disclaimer/>}/>
        <Route path="/termsncondition" element={<Termsncondition/>}/>
        <Route path="/500" element={<Error500/>}/>
        <Route path="/400" element={<Error400/>}/>
        // <Route path="/503" element={<Error503/>}/>
        <Route path="/sitemap" element={<Sitemap/>}/>

      </Routes>

      {!hideLayout && <Footer />}
      {!hideLayout && <Floatingbuttons />}
    </>
  );
}

export default function App() {

  return (
  <HelmetProvider>
    <Router>
      <PageTracking />
      <ScrollToTop/>
      <MainApp />
    </Router>
    </HelmetProvider>
  );
}
